import React from 'react';
import styles from './FJKeyword.module.less';
import FJTextWithEllipsis from '../FJTextWithEllipsis/FJTextWithEllipsis';

function FJKeyword({ keyword, onClick, active = true }) {
    return (
        <FJTextWithEllipsis
            onClick={() => {
                onClick(keyword);
            }}
            className={styles.keyword}
            text={keyword}
            isRender={active}
        />
    );
}

export default FJKeyword;
